import type { IssueMessageCountDto } from "@/model/tasks/issue-message-count-dto"
import type { IssueListItem } from "@/pages/Tasks/Issue/config"
import { useHttpClient } from "@/vf"
import { nextTick } from "vue"

export function useIssueMessageCount() {
    const http = useHttpClient()

    async function loadUnreadMessages(issues: IssueListItem[], viewMode: string = "customer") {
        if (!issues || issues.length === 0) {
            return
        }

        const issueIds = issues.map(issue => issue.id)

        const issueMessageCounts = (
            await http.get<IssueMessageCountDto[]>("tasks/issue/message-count", {
                issueIds,
                viewMode,
            })
        ).data

        // Update each issue with unread message IDs and message count
        await nextTick()
        for (const issue of issues) {
            const data = issueMessageCounts.find(i => i.issueId === issue.id)
            if (data) {
                issue.unreadMessageIds = data.unreadMessageIds
                issue.messageCount = data.messageCount
            } else {
                issue.unreadMessageIds = []
            }
        }
    }

    return {
        loadUnreadMessages,
    }
}
